import { render, staticRenderFns } from "./report-4-20.vue?vue&type=template&id=00774b02&scoped=true&"
import script from "./report-4-20.vue?vue&type=script&lang=ts&"
export * from "./report-4-20.vue?vue&type=script&lang=ts&"
import style0 from "./report-4-20.vue?vue&type=style&index=0&id=00774b02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00774b02",
  null
  
)

export default component.exports